'use strict';

import React from 'react';
import flux from 'utils/flux';
import t from 'tcomb-form';
import keybinding from 'react-keybinding';
import classnames from 'classnames';

var Form = t.form.Form;
var CreateBasket = t.struct({
    name: t.maybe(t.Str)
});

var BasketDropdown = React.createClass({

    displayName: 'BasketDropdown',

    mixins: [
        keybinding
    ],

    propTypes: {
        baskets:   React.PropTypes.object,
        mediaId:   React.PropTypes.string,
        mediaName: React.PropTypes.string,
        isFooter:  React.PropTypes.bool,
        media:     React.PropTypes.oneOfType([
                       React.PropTypes.object,
                       React.PropTypes.array
                   ])
    },

    keybindings: {
        'up': 'KEYUP',
        'down': 'KEYDOWN',
        'enter': 'ENTER',
        'esc': 'ESC'
    },

    onSubmit(e) {
        e.preventDefault();
        var basketData = this.refs.form.getValue();
        var media = [];
        var key = this.refs.filekey ? this.refs.filekey.getDOMNode().value : 'master';
        if ( this.props.mediaId && this.props.mediaName ) {
            media.push({
                id: this.props.mediaId,
                name: this.props.mediaName,
                key
            });
        } else {
            media = this.props.media;
        }

        flux.getStore('basket').createBasket( media, basketData.name );

        if ( this.props.mediaId ) {
            flux.getActions('media').toggleBasket(this.props.mediaId);
        }
    },

    getInitialState() {
        return {
            selected: 0,
            positionTop: 'auto'
        };
    },

    addToBasket( basket, e ) {
        e.preventDefault();
        this._addToBasket( basket );
    },

    _addToBasket( basket ) {
        let _media = [];
        const key  = 'master';

        if ( Array.isArray( this.props.media ) ) {
            this.props.media.forEach( item => {
                _media.push({
                    id:    item.id,
                    title: item.title,
                    key
                });
            });
        }
        else {
            _media.push({
                id:    this.props.media.get('id'),
                title: this.props.media.get('title'),
                key:   this.refs.filekey ? this.refs.filekey.getDOMNode().value : key
            });
        }

        flux.getStore('basket').addToBasket({
            basket: { id: basket.id, name: basket.name },
            media: _media
        }).then( () => {
            if (this.props.media) {
                flux.getActions('media').removeAllItemSelection();
            }
        });

        flux.getActions('media').closeBasket(this.props.mediaId);
    },

    keybinding(event, action) {
        event.preventDefault();
        if (action === 'KEYDOWN') {
            var selectedDown = (this.state.selected <= this.props.baskets.size - 2) ? (this.state.selected + 1) : 0;
            this.setState({selected: selectedDown});
        }

        if (action === 'KEYUP') {
            var selectedUp = (this.state.selected > 0) ? (this.state.selected - 1) : this.props.baskets.size - 1;
            this.setState({selected: selectedUp});
        }

        if (action === 'ENTER' && this.props.mediaId) {
            var basket = this.props.baskets.getIn([this.state.selected]).toJS();
            this._addToBasket(basket);
        }

        if (action === 'ESC' && this.props.mediaId) {
            flux.getActions('media').toggleBasket(this.props.mediaId);
        }
    },

    componentDidMount() {
        if (this.props.isFooter) {
            var height = this.refs.basket.getDOMNode().offsetHeight;
            this.setState({ positionTop: (height * -1) });
        }
    },

    render() {
        var baskets      = this.props.baskets.toJS();
        var media        = this.props.media;
        var mediaIsArray = Array.isArray( media );

        var options = {
            auto: 'placeholders',
            fields: {
                name: {
                    attrs: {
                        placeholder: flux.t('lightbox_create'),
                        autoFocus: this.props.baskets.size === 0
                    }
                }
            }
        };

        return (
            <div style={{top: this.state.positionTop}} ref="basket" className="basketdropdown">
                {()=>{
                    if ( !mediaIsArray ) {
                        const firstFile = media.get('files').first();
                        return (
                            <div>
                                <div className="basketdropdown__header" style={{display: 'none'}}>
                                    {flux.t('Select a file format')}
                                </div>
                                <div className="basketdropdown__filetypes" style={{display: 'none'}}>
                                    <select onChange={this.selectFileType} value={firstFile && firstFile.get('key') || ''} ref="filekey">
                                    {media.get('files').map( ( file, ix ) => {
                                        return (
                                            <option key={'file_'+ix} value={file.get('key')}>{file.get('name')} ({file.get('mimeType')})</option>
                                        );
                                    })}
                                    </select>
                                </div>
                            </div>
                        );
                    }
                }()}
                <div className="basketdropdown__header">
                    {flux.t('select_a_folder')}
                </div>
                <div className="basketdropdown__baskets">
                    {baskets.map( ( basket, ix ) => {
                        var isInBasket = false;
                        if ( media.get ) {
                            isInBasket = flux.getStore('basket').isInBasket( basket, media.get('id') );
                        }
                        return (
                            <button key={'basket-' + basket.id} onClick={this.addToBasket.bind(null, basket)} className={classnames('btn btn-border', {'active': ix === this.state.selected})}>
                                {basket.name} {isInBasket ? <i className="gopro-checkmark"/> : ''}
                            </button>);
                    })}
                </div>
                <div className="basketdropdown__create">
                    <form onSubmit={this.onSubmit}>
                        <Form
                          ref="form"
                          type={CreateBasket}
                          options={options}
                        />
                        <button className="btn btn-border btn-arrow" type="submit">
                            {flux.t('create')}
                            <i className="gopro-plus-small" />
                        </button>
                    </form>
                </div>
            </div>
        );
    }
});

module.exports = BasketDropdown;



// WEBPACK FOOTER //
// ./app/components/basket/basketDropdown.jsx